import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { AuthShell } from "@/components/AuthShell";
import { Field } from "@/components/common";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { PasswordInput } from "@/components/PasswordInput";
import { api, errMsg } from "@/lib/api";

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [link, setLink] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      const r = await api.post("/auth/forgot-password", { email });
      setLink(`${window.location.origin}${r.data.reset_path}`);
    } catch (err) { setError(errMsg(err)); } finally { setLoading(false); }
  };
  return (
    <AuthShell title="Recuperar senha" subtitle="Informe seu e-mail e geraremos um link para redefinir a senha."
      footer={<Link to="/login" data-testid="link-back-login" className="text-primary font-medium hover:underline">Voltar para o login</Link>}>
      {link ? (
        <div data-testid="reset-link-box" className="rounded-xl border border-emerald-500/40 bg-emerald-500/10 p-4 space-y-3">
          <p className="text-sm">Link de redefinição gerado (válido por 1 hora):</p>
          <a href={link} data-testid="reset-link" className="block text-xs break-all num text-primary underline">{link}</a>
          <Button asChild className="w-full" data-testid="reset-link-go"><a href={link}>Redefinir senha agora</a></Button>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <Field label="E-mail"><Input data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} /></Field>
          {error && <p data-testid="forgot-error" className="text-sm text-rose-500 bg-rose-500/10 rounded-lg px-3 py-2">{error}</p>}
          <Button data-testid="forgot-submit" type="submit" className="w-full h-11 rounded-xl font-semibold" disabled={loading}>{loading ? "Gerando..." : "Gerar link"}</Button>
        </form>
      )}
    </AuthShell>
  );
}

export function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [pwd, setPwd] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      await api.post("/auth/reset-password", { token: params.get("token"), new_password: pwd });
      toast.success("Senha redefinida! Faça login com a nova senha.");
      nav("/login");
    } catch (err) { setError(errMsg(err)); } finally { setLoading(false); }
  };
  return (
    <AuthShell title="Nova senha" subtitle="Escolha uma nova senha para sua conta.">
      <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
        <Field label="Nova senha (mín. 6 caracteres)"><PasswordInput data-testid="reset-password" required minLength={6} value={pwd} onChange={(e) => setPwd(e.target.value)} /></Field>
        {error && <p data-testid="reset-error" className="text-sm text-rose-500 bg-rose-500/10 rounded-lg px-3 py-2">{error}</p>}
        <Button data-testid="reset-submit" type="submit" className="w-full h-11 rounded-xl font-semibold" disabled={loading}>{loading ? "Salvando..." : "Salvar nova senha"}</Button>
      </form>
    </AuthShell>
  );
}
